import { createSlice } from '@reduxjs/toolkit'
import { initialState } from '../stepReducer/initialState.js'


export const adminReducer = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLogin: (state, action) => {
      // console.log(action.payload)
      state.login = {...state.login, ...action.payload };
    },
    setUser: (state, action) => {
      // //console.log(login, int)
      state.user = {...state.user, ...action.payload };
    },
  },
},
);

// Action creators are generated for each case reducer function

export const { setUser, setLogin,  } = adminReducer.actions;